
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface TagDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  tagName: string;
  onSave: (tagName: string) => Promise<void>;
  isSubmitting?: boolean;
}

const TagDialog: React.FC<TagDialogProps> = ({
  isOpen,
  setIsOpen,
  tagName: initialTagName,
  onSave,
  isSubmitting = false,
}) => {
  const [tagName, setTagName] = useState(initialTagName);

  // 确保每次打开对话框时更新 tagName 状态
  React.useEffect(() => {
    setTagName(initialTagName);
  }, [initialTagName, isOpen]);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTagName(e.target.value);
  };

  const handleSave = async () => {
    // Validate tag name isn't empty
    if (!tagName.trim()) {
      return;
    }
    
    await onSave(tagName);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {initialTagName ? 'Edit Tag' : 'Add Tag'}
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="name">Name</Label>
            <Input
              id="name"
              value={tagName}
              onChange={handleNameChange}
              disabled={isSubmitting}
            />
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => setIsOpen(false)} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={isSubmitting || !tagName.trim()}>
            {isSubmitting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Saving...
              </>
            ) : (
              'Save'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TagDialog;
